import { Card, Col, Row, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import './Contest/ContestDashboard.css'


const { Title, Text } = Typography;

const Home = () => {
  const navigate = useNavigate();

  return (
    <div>
      {/* <Title level={3} style={{ marginBottom: 24 }}>
        Home Dashboard
      </Title> */}
      <Row gutter={[20, 20]}>
      <div style={{ width: '100%' }}>
        <img 
          src='../images/bg.png' 
          alt="Home Image"
          style={{ maxWidth: '100%', height: 'auto', display: 'block' }}
        ></img>
      </div>
      </Row>
    </div>
  );
};

export default Home;
